import Plyr from 'plyr'

const $ = window.jQuery

/**
 * Applies consistent video player interface over html5 video and embed (YouTube & Vimeo) and applies the theme's styling
 */
const VideoPlayer = {

    /**
     * Initialise functionality
     */
    init() {

        // Disable for admin
        if ($('.block-editor').length) return

        this.initInstances(this.getEls())

        this.initModalChanges()

    },

    /**
     * Get elements that can be initialised by player
     * 
     * @param {jQuery el} $container Optional container to look into
     */
    getEls($container = false) {

        const selector = `
            .wp-block-video video, 
            .wp-block-embed .wp-block-embed__wrapper,
            div[data-plyr]
        `

        if ($container) {
            return $container.find(selector)
        } else {
            return $(selector)
        }

    },

    /**
     * Initialise videos with player
     * 
     * @param {jQuery el} $els 
     */
    initInstances($els) {

        $els.each(function () {
            // Check if already initialised
            if ($(this).closest('.plyr').length) return

            new Plyr(this)
        })

    },

    /**
     * Listen to modal changes
     */
    initModalChanges() {

        const vm = this

        $(window).on('modal-change', (e) => {

            const modalId = e.detail
            if (modalId === false) return

            setTimeout(() => {
                const $modal = $(`.modal-container[data-modal-id="${modalId}"]`)
                vm.initInstances(vm.getEls($modal))
            }, 100)

        })

    },

}

export default VideoPlayer;